import { render, staticRenderFns } from "./Customer360.vue?vue&type=template&id=3b326610&"
import script from "./Customer360.vue?vue&type=script&lang=js&"
export * from "./Customer360.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports